import { ServiceDetailModel } from "./service-detail-model";


export class ServiceCreatePayload {
  serviceHeaderId?: number;
  categoryId: number;
  serviceName: string;
  serviceDesc: string;
  serviceDefaultSmsCount: number;
  serviceIsactive: 'YES' | 'NO';
  clientId: number;
  serviceDetails: ServiceDetailModel[];

   constructor(init?: Partial<ServiceCreatePayload>) {
    Object.assign(this, init);
  }
}